import {
  CREATE_PRODUCT_RULE_DATA,
  CREATE_PRODUCT_RULE_REQUEST,
  FETCH_PRODUCT_RULE_DATA_REQUEST,
  FETCH_PRODUCT_RULE_DATA_SUCCESS,
  FETCH_PRODUCT_RULES_DATA_REQUEST,
  FETCH_PRODUCT_RULES_DATA_SUCCESS
} from "../constants/actionTypes";
import { createReducer } from "../utils";

const initialState = {
  productRule: {},
  productRules: {},
  error: "",
  isFetching: false,
  isCreating: false
};

export const productRulesReducer = createReducer(initialState, {
  [FETCH_PRODUCT_RULES_DATA_REQUEST]: (state, payload) => {
    const { page } = payload;
    return {
      ...state,
      productRules: {
        ...state.productRules,
        [page]: {
          isFetching: true,
          rules: []
        }
      }
    };
  },
  [FETCH_PRODUCT_RULES_DATA_SUCCESS]: (state, payload) => {
    const { page, data } = payload;
    return {
      ...state,
      productRules: {
        ...state.productRules,
        [page]: {
          isFetching: false,
          rules: data
        }
      }
    };
  },
  [CREATE_PRODUCT_RULE_REQUEST]: state => {
    return {
      ...state,
      isCreating: true,
      error: ""
    };
  },
  [CREATE_PRODUCT_RULE_DATA]: (state, payload) => {
    return {
      ...state,
      ...payload,
      isCreating: false
    };
  },
  [FETCH_PRODUCT_RULE_DATA_REQUEST]: state => {
    return {
      ...state,
      isFetching: true,
      productRule: {}
    };
  },
  [FETCH_PRODUCT_RULE_DATA_SUCCESS]: (state, payload) => {
    return {
      ...state,
      ...payload,
      isFetching: false
    };
  }
});

export default productRulesReducer;
